import React from "react";
import { Box, InputLabel, MenuItem, Select, TextField } from "@mui/material";

import { useStyles } from "../CreateLeague";
import { noOfPlayers } from "../mockData";

const LCLFields = ({ leagueData, handleFieldChange }) => {
  const classes = useStyles();

  return (
    <>
      <Box sx={{ mb: 1.5 }}>
        <InputLabel className={classes.inputLableStyles}>
          No. of Teams
        </InputLabel>

        <Select
          fullWidth
          name="noOfTeams"
          variant="outlined"
          value={leagueData.noOfTeams}
          className={classes.textFieldStyles}
          onChange={(e) => handleFieldChange(e.target.value, "noOfTeams")}
        >
          {noOfPlayers.map(({ id, number }) => (
            <MenuItem
              key={id}
              value={number}
            >
              {number}
            </MenuItem>
          ))}
        </Select>
      </Box>

      <Box sx={{ mb: 1.5 }}>
        <InputLabel className={classes.inputLableStyles}>
          Player per team
        </InputLabel>

        <TextField
          fullWidth
          variant="outlined"
          name="playersPerTeam"
          value={leagueData.playersPerTeam}
          className={classes.textFieldStyles}
          onChange={(e) => handleFieldChange(e.target.value, "playersPerTeam")}
        />
      </Box>

      <Box sx={{ mb: 1.5 }}>
        <InputLabel className={classes.inputLableStyles}>
          No. of Captains
        </InputLabel>

        <TextField
          fullWidth
          variant="outlined"
          name="noOfCaptains"
          className={classes.textFieldStyles}
          value={leagueData.noOfCaptains}
          onChange={(e) => handleFieldChange(e.target.value, "noOfCaptains")}
        />
      </Box>

      <Box sx={{ mb: 1.5 }}>
        <InputLabel className={classes.inputLableStyles}>
          Number of Matches Per Round
        </InputLabel>

        <TextField
          fullWidth
          name="matchesPerRound"
          variant="outlined"
          className={classes.textFieldStyles}
          value={leagueData.matchesPerRound}
          onChange={(e) => handleFieldChange(e.target.value, "matchesPerRound")}
        />
      </Box>
    </>
  );
};

export default LCLFields;
